<div style="max-height:60vh; overflow-y:auto;">	
	<ul ngbNav [(activeId)]="activeTabInFields" #nav="ngbNav" class="nav nav-tabs nav-justified">
	  <li [domId]="'fields'" ngbNavItem class="nav-item">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.fields }}
	    </a>	    
	    <ng-template ngbNavContent>
			<!-- // Field Prefs --> 
		     <form name="userForm" class="form">
		         <table class="table table-condensed table-hover" style="table-layout:fixed">
		             <thead>
		             <tr>
		                 <th>{{LOCALIZATION.field}}</th>
		                 <th>
		                     <label class="control control--checkbox" style="display:inline; margin-bottom:0px">
		                         <input 
		                         	type="checkbox" 
		                         	[(ngModel)]="all_results" 
		                         	(click)="toggleAllResult()"
		                         	id="all_results"
		                         	name="all_results"
		                         	aria-label="Enable all fields as results fields" />
		                         <div class="control__indicator"></div>
		                     </label>
		                     <span>{{LOCALIZATION.result}}</span>
		                 </th>
		                 <th>
		                     <label class="control control--checkbox" style="display:inline;margin-bottom:0px">
		                         <input 
		                         	type="checkbox" 
		                         	[(ngModel)]="all_search" 
		                         	(click)="toggleAllSearch()" 
		                         	id="all_search"
		                         	name="all_search"
		                         	aria-label="Enable all fields as search fields" />
		                         <div class="control__indicator"></div>
		                     </label>
		                     <span>{{LOCALIZATION.search}}</span>
		                 </th>
		                 <th>
		                     <label class="control control--checkbox" style="display:inline;margin-bottom:0px">
		                         <input 
		                         	type="checkbox" 
		                         	[(ngModel)]="all_metadata" 
		                         	(click)="toggleAllMetadata()"
		                         	id="all_metadata" 
		                         	name="all_metadata"
		                         	aria-label="Enable all fields as metadata fields" />
		                         <div class="control__indicator"></div>
		                     </label>
		                     <span>{{LOCALIZATION.metadata}}</span>
		                 </th>
		             </tr>
		             </thead>
		             <tbody>
		                 <tr *ngFor="let field of fieldPrefs" [hidden]="!field.isAvailable">
		                     <td class="truncate" title="{{field.displayName}}">{{field.displayName}}</td>
		                     <td class="text-center">
		                         <label class="control control--checkbox" title="{{LOCALIZATION.result}}">
		                             <input 
		                             	type="checkbox" 
		                             	[(ngModel)]="field.isResult"
		                                (click)="checkAllResults()"
		                                [id]="'result' + field.name"
		                                [name]="'result' + field.name"
		                                [attr.aria-label]="field.displayName + ' is result field'" />
		                             <div class="control__indicator"></div>
		                         </label>
		                     </td>
		                     <td class="text-center">
		                         <label class="control control--checkbox" title="{{LOCALIZATION.search}}">
		                             <input 
		                             	type="checkbox" 
		                             	[(ngModel)]="field.isSearch"
		                                (click)="checkAllSearch()"
		                                [id]="'search' + field.name"
		                                [name]="'search' + field.name"
		                                [attr.aria-label]="field.displayName + ' is search field'" />
		                             <div class="control__indicator"></div>
		                         </label>
		                     </td>
		                     <td class="text-center">
		                         <label class="control control--checkbox" title="{{LOCALIZATION.metadata}}">
		                             <input 
		                             	type="checkbox" 
		                             	[(ngModel)]="field.isMetadata"
		                                (click)="checkAllMetadata()"
		                                [id]="'metadata' + field.name"
		                                [name]="'metadata' + field.name"
		                                [attr.aria-label]="field.displayName + ' is metadata field'" />
		                             <div class="control__indicator"></div>
		                         </label>
		                     </td>
		                 </tr>
		             </tbody>
		         </table>     
		     </form>			
	    </ng-template>
	  </li>
	  <li [domId]="'order'" ngbNavItem class="nav-item">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.order }}
	    </a>	    
	    <ng-template ngbNavContent>
	 		<!-- // Field Order -->
		     <form name="userFieldOrderForm" class="form">
		         <div class="col-sm-6">
		             <table class="table table-condensed table-hover" style="table-layout:fixed">
		                 <thead>
		                 <tr class="stickyrow">
		                     <th style="display:block;">{{LOCALIZATION.search}} {{LOCALIZATION.field}}</th>                                  
		                 </tr>
		                 </thead>
		                 <tbody>
							<tr *ngFor="let field of searchFieldOrderPrefs; let i = index; trackBy: trackByIndex"
							    [class.dragged]="dragIndex === i && dragContext === 'search'"
							    [draggable]="true"
							    (dragover)="dragActions('enter', 'search', i, $event)"
							    (dragleave)="dragActions('leave', 'search', i, $event)"
							    (dragend)="dragActions('end', 'search', i, $event)"
							    [hidden]="!field.isAvailable">
							    
							    <td class="truncate" [title]="field.displayName">
							        {{ field.displayName }}
							        <i [title]="LOCALIZATION.dragDropFieldTooltip" class="right fas fa-ellipsis-v drag circleme"></i>
							    </td>
							</tr>
		                 </tbody>
		             </table>
		         </div>
		         <div class="col-sm-6">
		             <table class="table table-condensed table-hover" style="table-layout:fixed">
		                 <thead>
		                 <tr class="stickyrow">
		                     <th style="display:block;">{{LOCALIZATION.result}} {{LOCALIZATION.field}}</th>                                  
		                 </tr>
		                 </thead>
		                 <tbody>
							<tr *ngFor="let field of resultFieldOrderPrefs; let i = index; trackBy: trackByIndex"
							    [class.dragged]="dragIndex === i && dragContext === 'result'"
							    [draggable]="true"
							    (dragover)="dragActions('enter', 'result', i, $event)"
							    (dragleave)="dragActions('leave', 'result', i, $event)"
							    (dragend)="dragActions('end', 'result', i, $event)"
							    [hidden]="!field.isAvailable">
							    
							    <td class="truncate" [title]="field.displayName">
							        {{ field.displayName }}
							        <i [title]="LOCALIZATION.dragDropFieldTooltip" class="right fas fa-ellipsis-v drag circleme"></i>
							    </td>
							</tr>		                     
		                 </tbody>
		             </table>
		         </div>
		     </form>
	    </ng-template>
	  </li>  
	</ul>
	<div [ngbNavOutlet]="nav" class="tab-content"></div>
</div>	
   	